import { Component, ChangeDetectorRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { Location } from '@angular/common';
import { ErrorService } from '../../services/error/error.service';
import { FileService } from '../../services/file.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { EnvironmentService } from '../../services/environment.service';
import { CommunicationService } from '../../services/communication.service';
import { DrrCcdDeviceApplicationDto } from '../technical-data/technical-data.domain';
import { DrrCcdDeviceService } from '../technical-data/technical-data.service';
import { GridCompatibilityCommentsService } from 'src/app/+grid-compatibility/services/grid-compatibility-comments.service';
import { GridCompatibilityProcessStatus } from 'src/app/+grid-compatibility/entities/enums/gridCompatibilityProcessStatus';
import { GridCompatibilityOrderProcessService } from 'src/app/+grid-compatibility/services/grid-compatibility-order-process.service';
import { PersonalDataFormNewComponent } from 'src/app/+grid-application-shared/components/personal-data-form-new/personal-data-form-new.component';

@Component({
  selector: 'app-personal-data-form',
  templateUrl: '../../+grid-application-shared/components/personal-data-form-new/personal-data-form-new.component.html',
  styleUrls: ['./ccd-drr-personal-data-form.component.scss'],
})
export class CcdDrrPersonalDataFormComponent extends PersonalDataFormNewComponent<DrrCcdDeviceApplicationDto> {
  constructor(
    commonService: CommonService,
    router: Router,
    route: ActivatedRoute,
    location: Location,
    drrCcdApplicationService: DrrCcdDeviceService,
    drrCcdCommentService: GridCompatibilityCommentsService,
    errorService: ErrorService,
    fileService: FileService,
    localStorageService: LocalStorageService,
    cdRef: ChangeDetectorRef,
    environmentService: EnvironmentService,
    communicationService: CommunicationService,
    zone: NgZone,
    private orderProcessService: GridCompatibilityOrderProcessService
  ) {
    super(
      commonService,
      router,
      route,
      location,
      drrCcdApplicationService,
      drrCcdCommentService,
      errorService,
      fileService,
      localStorageService,
      cdRef,
      environmentService,
      communicationService,
      zone
    );

    this.applicationTypeText = 'installation-data.ccd-drr';
  }

  protected loadOrderProcess(): void {
    this.preventLeak(this.orderProcessService.orderProcess$).subscribe(orderProcess =>
      this.setEditabilityBasedOnProcessStatus(orderProcess.status)
    );

    this.orderProcessService.loadOrderProcess(this.applicationId);
  }

  private setEditabilityBasedOnProcessStatus(gridCompProcessStatus: GridCompatibilityProcessStatus): void {
    const externalRoleEditableStatuses = [GridCompatibilityProcessStatus.OpenIssue];
    const internalRoleEditableStatuses = [GridCompatibilityProcessStatus.RequestUpdated, GridCompatibilityProcessStatus.RequestSent];

    this.editabilityBasedOnProcessStatus.technicianRole = externalRoleEditableStatuses.includes(gridCompProcessStatus);
    this.editabilityBasedOnProcessStatus.customerRole = externalRoleEditableStatuses.includes(gridCompProcessStatus);
    this.editabilityBasedOnProcessStatus.internalRoles = internalRoleEditableStatuses.includes(gridCompProcessStatus);
  }
}
